
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-events/amenities",
      function () {
        return require("private-next-pages/private-events/amenities.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private-events/amenities"])
      });
    }
  